import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {SelectToolboxTabPanel} from '../../models/redux/selectToolboxTabPanel'
import {SetPixaBayKeyword} from '../../models/redux/setPixaBayKeyword'
import {SetGraphics} from '../../models/redux/setGraphics'
import {SetGraphicCategories} from '../../models/redux/setGraphicCategories'
import {initialToolboxStore} from './toolbox.store'

const toolboxSlice = createSlice({
  name: 'toolbox',
  initialState: initialToolboxStore,
  reducers: {
    resetToolboxStore(state) {
      state = initialToolboxStore
    },
    selectToolboxTabPanel(state, action: PayloadAction<SelectToolboxTabPanel>) {
      state.activeTabPanel = action.payload.tabPanel
      state.selectForMasked = action.payload.selectForMasked
    },
    setPixaBayKeyword(state, action: PayloadAction<SetPixaBayKeyword>) {
      state.pixaBayKeyword = action.payload.keyword
    },
    setGraphics(state, action: PayloadAction<SetGraphics>) {
      state.graphics = action.payload.graphics
    },
    setGraphicCategories(state, action: PayloadAction<SetGraphicCategories>) {
      state.graphicCategories = action.payload.graphicCategories
    },
  },
})

export const {
  resetToolboxStore,
  selectToolboxTabPanel,
  setPixaBayKeyword,
  setGraphics,
  setGraphicCategories,
} = toolboxSlice.actions
export default toolboxSlice.reducer
